export enum EOrderStatus {
  PENDING = 10,
  APPROVED = 20,
  CONFIRM = 21,
  REJECTED = 29,
  RECEIVED = 30,
  COMPLETED = 40,
  POD = 50,
  CANCEL = 4,
  RETURN = 60,
  PARTIAL_RETURN = 70,
}

export enum EOrderType {
  INTERNAL = 1,
  EXPORT = 2,
}

export enum EDeliveryStatus {
  PENDING = 1,
  CHECKIN = 2,
  ON_DELIVERY = 3,
  CHECKOUT = 4,
  DELIVERYED = 5,
}

export enum EOrderPalletStatus {
  PENDING = 1,
  RECEIVED = 2,
  DELIVERED = 3,
}
